import { render } from "./forward.vue?vue&type=template&id=799abfc4&scoped=true&ts=true"
import script from "./forward.vue?vue&type=script&lang=ts"
export * from "./forward.vue?vue&type=script&lang=ts"

import "./forward.vue?vue&type=style&index=0&id=799abfc4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799abfc4"]])

export default __exports__